/**
 * The sentence after `marker:` when the error's message starts with it,
 * otherwise null (also null when nothing follows the marker).
 *
 * tRPC drops error causes, so a backend refusal meant for one form field
 * carries its marker as a message prefix; the rest of the message is already
 * a plain sentence.
 */
export function markedFieldMessage(error: unknown, marker: string): string | null {
  if (!error || typeof error !== 'object') return null;
  const message = (error as { message?: unknown }).message;
  const prefix = `${marker}:`;
  if (typeof message !== 'string' || !message.startsWith(prefix)) return null;
  return message.slice(prefix.length).trim() || null;
}
